import React, { useEffect } from "react";
import SalesBusinessActivityTable from "./components/Sales-Business-Table/SalesBusinessActivityTable";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  resetFilters,
  selectIsLoadingBusinesses,
  selectTotalBusinessCount,
  setFilters,
} from "../businesses/businessesSlice";
import RevenueOverview from "./components/Revenue-Overview/RevenueOverview";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import BusinessesMap from "./components/Businesses-Map/BusinessesMap";
import { EuroOutlined } from "@ant-design/icons";
// import SalesActionMenu from "./components/SalesActionMenu";
import { fetchSalesReps } from "./SalesSlice";

function Sales() {
  const dispatch = useAppDispatch();
  const totalCount = useAppSelector(selectTotalBusinessCount);
  const loading = useAppSelector(selectIsLoadingBusinesses);
  useEffect(() => {
    dispatch(setFilters({}));
    dispatch(fetchSalesReps());
    return () => {
      dispatch(resetFilters());
    };
  }, []);

  return (
    <div>
      <GeneralTableHeader
        title="Sales Team Manager"
        description="Associate a merchant with its sales representative and track sales commissions."
        actionButtons={[<BusinessesMap />]}
        avatarUrl={<EuroOutlined style={{ fontSize: "30px" }} />}
        statisticsCount={totalCount}
        statisticsLabel="Amount of Merchants"
        statisticsLoading={loading}
      >
        <>
          <RevenueOverview></RevenueOverview>
        </>
      </GeneralTableHeader>

      <SalesBusinessActivityTable></SalesBusinessActivityTable>
    </div>
  );
}

export default Sales;
